import SortList from "components/Blocks/SortList/SortList";

export default SortList;
